import React from 'react';
import { useParams } from 'react-router-dom';
import PageView from '../components/sections/PageView';

const URL_TO_SLUG = {
  'chaat': 'menu_chaat',
  'woodfire-tandoors': 'menu_woodfire',
  'reimagined-regions': 'menu_regions',
  'rustic-classics': 'menu_classics',
  'flour-water': 'menu_flour_water',
};

const MenuCategoryPage = () => {
  const { category } = useParams();
  const slug = URL_TO_SLUG[category] || `menu_${category}`;
  return <PageView slug={slug} backTo="/menu" backLabel="Back to Menu" />;
};

export default MenuCategoryPage;
